import React from 'react';

const Refresh = ({ fill }) => (
  <svg
    width="19px"
    height="20px"
    viewBox="0 0 19 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M6.688485,0.6539 C9.880853,-0.14096 13.322823,0.93531 15.491363,3.40219 C15.649133,3.57798 15.667143,3.8455 15.491363,4.02128 C15.333603,4.17906 15.030043,4.20135 14.872273,4.02128 C13.748153,2.73929 12.263833,1.83468 10.600343,1.45738 C7.94381,0.85104 5.103058,1.68975 3.189175,3.61733 C1.187837,5.63663 0.4195462,8.60443 1.161256,11.343944 C1.306112,11.8929 0.4589398,12.125276 0.3131706,11.580776 C-0.16958088,9.793727 -0.09927112,7.86189 0.5592657,6.12809 C1.582193,3.43731 3.887071,1.3476 6.688485,0.6539 Z"
        id="RefreshIcon-path-1"
      />
      <path
        d="M14.543113,0.0134 C14.758323,-0.04407 15.039583,0.08799 15.083313,0.32037 C15.276263,1.40851 15.474323,2.49751 15.667263,3.58649 C15.719573,3.87203 15.548063,4.13528 15.245373,4.14385 C14.138373,4.17472 13.032273,4.20988 11.926133,4.24075 C11.360233,4.25789 11.364513,3.37983 11.922733,3.35925 C13.029733,3.32838 14.135833,3.29323 15.241973,3.26236 L14.722573,3.27831 L14.236153,0.5536 C14.2016343,0.34952375 14.2741269,0.139544531 14.4576505,0.0460034766 L14.543113,0.0134 Z M15.241973,3.26236 L14.722573,3.27831 L14.820093,3.81972 L14.820093,3.81972 C14.960723,3.63537 15.101333,3.45101 15.241973,3.26236 Z"
        id="RefreshIcon-path-3"
      />
      <path
        d="M16.560803,5.72024 C16.806903,5.65421 17.013543,5.80769 17.101003,6.02721 C17.803263,7.82786 17.895873,9.8643 17.347093,11.721571 C16.522173,14.522108 14.304873,16.783193 11.521463,17.665522 C8.342707,18.675498 4.791219,17.744327 2.481951,15.356254 C2.086653,14.952389 2.705744,14.329003 3.101041,14.737164 C4.317797,15.9933 5.898088,16.826766 7.627602,17.103725 C10.331993,17.538359 13.115383,16.480288 14.898063,14.421505 C16.834253,12.186871 17.321283,9.003944 16.250303,6.26004 L16.250303,6.26004 L16.2309768,6.18599001 C16.2042697,5.98496494 16.3710163,5.77130667 16.560803,5.72024 Z"
        id="RefreshIcon-path-4"
      />
      <path
        d="M5.990634,14.390492 C6.556558,14.359629 6.552278,15.237673 5.990634,15.268541 C4.883634,15.334568 3.781705,15.395448 2.675561,15.457186 L3.205573,15.42831 L3.43314138,16.5243389 L3.43314138,16.5243389 L3.768819,18.1488222 C3.816849,18.3811978 3.70279,18.6230102 3.465278,18.6924661 C3.245766,18.7499344 2.973099,18.6178759 2.92508,18.3855002 C2.701288,17.300759 2.477473,16.221198 2.25368,15.1365 C2.19281,14.846678 2.377156,14.596287 2.675561,14.579137 C3.782561,14.51311 4.88449,14.45223 5.990634,14.390492 Z M3.097441,14.899822 C2.956817,15.084177 2.816202,15.268537 2.675561,15.457186 L3.205573,15.42831 L3.097441,14.899822 L3.097441,14.899822 Z"
        id="RefreshIcon-path-7"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-433.000000, -911.000000)">
        <g transform="translate(433.151427, 911.070690)">
          <mask id="RefreshIcon-mask-2" fill="white">
            <use xlinkHref="#RefreshIcon-path-1" />
          </mask>
          <g />
          <polygon
            fill={fill}
            mask="url(#RefreshIcon-mask-2)"
            points="-5 -4.60415 20.616533 -4.60415 20.616533 16.89076 -5 16.89076"
          />
          <mask id="RefreshIcon-mask-4" fill="white">
            <use xlinkHref="#RefreshIcon-path-3" />
          </mask>
          <g />
          <polygon
            fill={fill}
            mask="url(#RefreshIcon-mask-4)"
            points="6.50289 -5 20.676583 -5 20.676583 9.240976 6.50289 9.240976"
          />
          <mask id="RefreshIcon-mask-6" fill="white">
            <use xlinkHref="#RefreshIcon-path-4" />
          </mask>
          <g />
          <polygon
            fill={fill}
            mask="url(#RefreshIcon-mask-6)"
            points="-2.644921 0.70477 22.701783 0.70477 22.701783 23.068609 -2.644921 23.068609"
          />
          <mask id="RefreshIcon-mask-8" fill="white">
            <use xlinkHref="#RefreshIcon-path-7" />
          </mask>
          <g />
          <polygon
            fill={fill}
            mask="url(#RefreshIcon-mask-8)"
            points="-2.757916 9.389698 11.413473 9.389698 11.413473 23.705864 -2.757916 23.705864"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Refresh;
